import React from "react";
import HeroSlider from './HeroSlider';
import CircleContactCard from './CircleContactCard';
import AboutUs from './AboutUs';
import Content from './Content';
import OurBusiness from './OurBusiness';
import Services3D from './Services3D';
import Image from './Image'
import Footer from "./Footer";
import { useTranslation } from "react-i18next";

function Home() {
  const { i18n } = useTranslation();
  const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';

  return (
    <div dir={direction} >
      <HeroSlider />
      <CircleContactCard />

     
{/* OurBusiness always LTR */}
      <div style={{
        maxWidth: '1300px',
        margin: '0 auto',
        overflowX: 'hidden',
      }}>
        <div dir="ltr">
          <OurBusiness />
        </div>
      </div>
   
      <Services3D />
       <div dir="ltr"> <Content /></div>
    
 
    <Image/>
      <AboutUs />
     
      <Footer />
    </div>
  );
}

export default Home;
